import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

export function getDirection(language: string): 'rtl' | 'ltr' {
  return language === 'ar' ? 'rtl' : 'ltr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
  });

// Set initial direction
document.documentElement.dir = getDirection(i18n.language);
document.documentElement.lang = i18n.language;

// Update direction when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = getDirection(lng);
  document.documentElement.lang = lng;
});

export default i18n;
